import { Clazz, deserialize } from 'serializr';
import { EntityList, entityListSchema } from '..';
import { LabelValue, LabelValueArray, ObjectType } from './models';



export const isValidEmail = (email: string): boolean => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};

function newEntityListFrom<T>(Type: Clazz<T>, items: T[]): EntityList<T> {
    return deserialize(entityListSchema(Type), {
        type: 'load',
        items
    });
}

export const getLabelValueArrayFromObject = (obj: ObjectType): LabelValueArray =>
    Object.entries(obj).map(([key, value]) => ({
        label: value,
        value: key
    }));

export const getLabelValueObjectFromObjectAndKey = (key: string, obj: ObjectType): LabelValue => ({
    label: obj[key],
    value: key
});
export default newEntityListFrom;

export const getLabelValuePairs = (obj: ObjectType, key?: string): LabelValue | LabelValueArray =>
    key ? getLabelValueObjectFromObjectAndKey(key, obj) : getLabelValueArrayFromObject(obj);
